import { parseISO } from '@sequencehq/utils/dates'
import { getActivePhaseStart } from '@sequencehq/utils'
import { BillingSchedule } from 'modules/Customer/hooks/useFetchBillingSchedules'

/**
 * The earliest a renewal may begin: the start of the currently active phase
 * (the renewal may begin on that same day).
 */
export const getRenewalStartMinDate = (
  schedule: BillingSchedule | undefined,
  today: Date
): Date | undefined => {
  if (!schedule) {
    return undefined
  }
  const activePhaseStart = getActivePhaseStart(schedule.phases, today)
  return activePhaseStart ? parseISO(activePhaseStart) : undefined
}
